import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../../lib/utils';
import { SpecraBadge } from '../ensigns/badge';
/** An ordered run of badges, e.g. the agencies on a career path. */ export function SpecraBadgeSequence({ align = 'start', className, getItemTestId, items, label, separator = 'arrow', ...props }) {
    return /*#__PURE__*/ _jsx("ol", {
        "aria-label": label,
        className: cn('m-0 flex list-none flex-wrap items-center gap-[var(--space-1-5)] p-0', align === 'end' && 'justify-end', className),
        ...props,
        children: items.map((item, index)=>/*#__PURE__*/ _jsxs("li", {
                className: "flex items-center gap-[var(--space-1-5)]",
                "data-item-id": item.id,
                "data-testid": getItemTestId?.(item),
                children: [
                    index > 0 ? /*#__PURE__*/ _jsx("span", {
                        "aria-hidden": "true",
                        className: "text-muted-foreground",
                        children: separator === 'dot' ? '·' : '→'
                    }) : null,
                    /*#__PURE__*/ _jsx(SpecraBadge, {
                        variant: item.variant ?? 'neutral',
                        children: item.label
                    })
                ]
            }, item.id))
    });
}
